export function RouteLoading() {
  return (
    <div className="empty-state term-text" role="status">
      &gt; טוען...
      <span className="term-cursor" aria-hidden="true" />
    </div>
  );
}
